<template>
	<div>
		<PageHeader
			:data="{
				name: 'Municipalities Map',
				breadcrumbs: [{ name: 'Home', to: '/' }],
			}"
		/>

		<router-link class="btn btn-primary mb-2" :to="'/municipalities'">
			🏙️ Municipalities
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/contacts'">
			📙 Municipalities Contacts
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2 active" :to="'/municipality-map'">
			📍 Map
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipalities-missing'">
			Municipalities Missing
		</router-link>
		<router-link class="btn btn-primary mb-2 ms-2" :to="'/municipality-map/polygons'">
			Map Polygons
		</router-link>

		<div class="map-wrapper">
			<div class="actions mb-3 d-none">
				<gmap-autocomplete @place_changed="inputLocation" />
			</div>
			<div class="card mb-3">
				<div class="card-body">
					<div class="row">
						<!-- Municipality Search (levo) -->
						<div class="col-md-6">
							<div class="border rounded p-3 mb-4">
								<h5>Municipality Search</h5>

								<div v-if="!selectedMunicipality">
									<MunicipalityAdvancedSearch :excludeNoMap="true" class="mb-2" v-on:setMunicipality="choosenMunicipality" />
								</div>
								<div class="d-flex justify-content-start align-items-center mb-2" v-else>
									<h4 class="p-0 m-0">{{ selectedMunicipality.full_name }}</h4>
									<button @click="changeMunicipality" class="btn btn-secondary btn-sm ms-2">Change</button>
								</div>

								<div class="form-group mb-2">
									<label>Radius</label>
									<div class="input-group">
										<input class="form-control" type="number" v-model="radius" />
										<span class="input-group-text">miles</span>
									</div>
								</div>

								<div class="form-check mb-1">
									<input class="form-check-input" v-model="sameState" type="checkbox" id="sameState" />
									<label class="form-check-label" for="sameState">Same State</label>
								</div>
								<div class="form-check mb-1">
									<input class="form-check-input" v-model="sameCounty" type="checkbox" id="sameCounty" />
									<label class="form-check-label" for="sameCounty">Same County</label>
								</div>
								<div class="form-check mb-1">
									<input class="form-check-input" v-model="twClient" type="checkbox" id="twClient" />
									<label class="form-check-label" for="twClient">TW Client</label>
								</div>
								<div class="form-check mb-1">
									<input class="form-check-input" v-model="hgClient" type="checkbox" id="hgClient" />
									<label class="form-check-label" for="hgClient">HG Client</label>
								</div>
								<div class="form-check mb-1">
									<input class="form-check-input" v-model="notTwClient" type="checkbox" id="notTwClient" />
									<label class="form-check-label" for="notTwClient">NOT TW Client</label>
								</div>
								<div class="form-check mb-1">
									<input class="form-check-input" v-model="notHgClient" type="checkbox" id="notHgClient" />
									<label class="form-check-label" for="notHgClient">NOT HG Client</label>
								</div>
								<div class="form-check mb-3">
									<input class="form-check-input" v-model="skipIfSentInLast4Weeks" type="checkbox" id="skipIfSentInLast4Weeks" />
									<label class="form-check-label" for="skipIfSentInLast4Weeks">Skip if sent in last 4 weeks</label>
								</div>

								<button class="btn btn-primary" :disabled="selectedMunicipality == null || radius == ''" @click="applyMunicipalityFilters()">
									Apply Radius Filters
								</button>
							</div>
						</div>

						<!-- Polygon Search (desno) -->
						<div class="col-md-6">
							<div class="border rounded p-3 mb-4">
								<h5>Polygon Search</h5>

								<div class="form-group mb-2">
									<label>Select Polygon</label>
									<select class="form-select" v-model="selectedPolygonIndex" @change="onPolygonChange">
										<option value="null">Select polygon</option>
										<option v-for="(polygon, index) in polygons" :key="index" :value="index">
											{{ polygon.name }}
										</option>
									</select>
								</div>

								<div class="form-check mb-1">
									<input class="form-check-input" v-model="polygonTwClient" type="checkbox" id="polygonTwClient" />
									<label class="form-check-label" for="polygonTwClient">TW Client</label>
								</div>
								<div class="form-check mb-1">
									<input class="form-check-input" v-model="polygonHgClient" type="checkbox" id="polygonHgClient" />
									<label class="form-check-label" for="polygonHgClient">HG Client</label>
								</div>
								<div class="form-check mb-1">
									<input class="form-check-input" v-model="polygonNotTwClient" type="checkbox" id="polygonNotTwClient" />
									<label class="form-check-label" for="polygonNotTwClient">NOT TW Client</label>
								</div>
								<div class="form-check mb-1">
									<input class="form-check-input" v-model="polygonNotHgClient" type="checkbox" id="polygonNotHgClient" />
									<label class="form-check-label" for="polygonNotHgClient">NOT HG Client</label>
								</div>
								<div class="form-check mb-3">
									<input class="form-check-input" v-model="polygonSkipIfSentInLast4Weeks" type="checkbox" id="polygonSkipIfSentInLast4Weeks" />
									<label class="form-check-label" for="polygonSkipIfSentInLast4Weeks">Skip if sent in last 4 weeks</label>
								</div>

								<button class="btn btn-primary" :disabled="selectedPolygonIndex == 'null'" @click="applyPolygonFilters()">Apply Polygon Filters</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="card mb-3">
				<div class="card-body">
					<div class="alert alert-info bg-info-lighter text-info">
						👋 Hover on map marker will show you municipality name. Click on map marker will give you more information about that municipality.
					</div>
					<div class="map-conteiner">
						<div class="map-overlay-info" v-if="showInfo">
							<div v-if="!loadingInfo" class="municipality-info">
								<div class="text-white">
									<div class="row border-bottom mb-2 pb-1">
										<div class="col-1"><h1>🏛️</h1></div>
										<div class="col-6">
											<h4 class="mb-0">{{ municipalityInfo.full_name }}</h4>
											<span>{{ municipalityInfo.county }}, {{ municipalityInfo.state }}</span>
										</div>
										<div class="col-5 d-flex justify-content-end align-items-end mb-3">
											<a class="btn btn-sm btn-primary" :href="'/municipalities/edit/' + municipalityInfo.id"> Visit</a>
										</div>
									</div>
									<div class="row">
										<div class="col-6">
											<p class="m-0 p-0 mb-2"><b>Population</b>: 🧑‍🤝‍🧑 {{ municipalityInfo.population }}</p>
											<p class="m-0 p-0 mb-2">
												<b>FIPS</b>:
												<a target="_blank" :href="'https://google.com/search?q=FIPS+' + municipalityInfo.fips">{{ municipalityInfo.fips }}</a>
											</p>
											<p class="m-0 p-0 mb-2"><b>FIPS full</b>: {{ municipalityInfo.fips_full }}</p>
											<p class="m-0 p-0 mb-2"><b>Deliveries sent</b>: {{ municipalityInfo.contacts.length }} 📨</p>
											<p class="m-0 p-0 mb-2"><b>Contacts</b>: {{ municipalityInfo.contacts.length }} 👤</p>
											<p class="m-0 p-0 mb-2">
												<b>Website</b>:
												<a :href="municipalityInfo.website" target="_blank">{{ municipalityInfo.website }} 🔗</a>
											</p>
										</div>
										<div class="col-6">
											<p class="m-0 p-0 mb-2"><b>State</b>: {{ municipalityInfo.state }}</p>
											<p class="m-0 p-0 mb-2"><b>City</b>: {{ municipalityInfo.city }}</p>
											<p class="m-0 p-0 mb-2"><b>Address</b>: {{ municipalityInfo.address_street }}</p>
											<p class="m-0 p-0 mb-4"><b>Zip</b>: {{ municipalityInfo.zip }}</p>
											<p class="m-0 p-0 mb-2">
												<b>TW customer</b>:
												<span v-if="municipalityInfo.tw_customer" class="badge badge-success bg-success">Yes</span>
												<span v-else class="badge badge-danger bg-danger">No</span>
											</p>
											<p class="m-0 p-0 mb-2">
												<b>HG customer</b>:
												<span v-if="municipalityInfo.hg_customer" class="badge badge-success bg-success">Yes</span>
												<span v-else class="badge badge-danger bg-danger">No</span>
											</p>
										</div>
									</div>
									<!---->
								</div>
								<div class="d-flex justify-content-center align-items-center">
									<button class="btn btn-danger btn-sm" @click="showInfo = false">Close</button>
								</div>
							</div>
							<div v-else>
								<div class="d-flex justify-content-center">
									<div class="spinner-border text-light" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>
								</div>
							</div>
						</div>
						<div v-if="loading" class="map-overlay-loading">
							<div class="d-flex justify-content-center">
								<div class="spinner-border text-light" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
							</div>
						</div>
						<GmapMap :center="center" :zoom="zoom" map-type-id="terrain" style="width: 100%; height: 500px">
							<GmapMarker
								:key="index"
								v-for="(m, index) in markers"
								:position="m.position"
								:title="m.title"
								:clickable="true"
								:draggable="false"
								@click="showMunicipalityInfo(m)"
							/>
							<GmapCircle :center="center" :radius="radius * 1609" :strokeColor="'#000'" :fillColor="'transparent'" />
							<GmapPolygon :paths="polygonPaths" :strokeColor="'#FF0000'" :fillOpacity="0.3" :fillColor="'#FF0000'" />
						</GmapMap>
					</div>
				</div>
			</div>

			<div class="card" v-if="municipalities.length > 0">
				<div class="card-body">
					<div class="row">
						<div class="col-md-10">
							<button
								v-if="authUser.permissions.includes('CAMPAIGN_CREATE')"
								data-bs-toggle="modal"
								data-bs-target="#campaignModal"
								class="btn btn-secondary btn-sm me-2"
								@click="getCampaignMunicipalities()"
							>
								Create Campaign <font-awesome-icon :icon="['fas', 'plus-circle']" class="me-1" />
							</button>
							<button class="btn btn-warning btn-sm me-2" @click="exportMunicipalitiesInPolygon()">
								Export Polygon <font-awesome-icon :icon="['fas', 'cloud-download-alt']" class="me-1" />
							</button>
							<button class="btn btn-warning btn-sm me-2" @click="exportMunicipalitiesInRadius()">
								Export Radius <font-awesome-icon :icon="['fas', 'cloud-download-alt']" class="me-1" />
							</button>
						</div>
						<div class="col-md-2 float-end d-flex justify-content-end align-items-center">
							<span class="badge badge-primary">{{ municipalities.length }}</span>
						</div>
					</div>
					<table class="table table-hover">
						<thead>
							<tr>
								<th>Name</th>
								<th>State</th>
								<th>County</th>
								<th>Email</th>
								<th>Phone</th>
								<th>Population</th>
								<th>Actions</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="muny in municipalities" :key="muny.id">
								<td>{{ muny.full_name }}</td>
								<td>{{ muny.state }}</td>
								<td>{{ muny.county }}</td>
								<td>{{ muny.email }}</td>
								<td>{{ muny.phone }}</td>
								<td>{{ muny.population }}</td>
								<td>
									<a class="btn btn-primary btn-sm" target="_blank" :href="'/municipalities/edit/' + muny.id">
										Details
									</a>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<!-- Modal for creating campaign -->
		<div class="modal fade" id="campaignModal" tabindex="-1" aria-labelledby="campaignModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<form @submit.prevent="createCampaign">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Create Campaign</h5>
							<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<div class="modal-body">
							<div class="form-group mb-2">
								<label for="">Campaign Name</label>
								<div class="input-group mb-3">
									<input type="text" class="form-control" placeholder="Campaign name" v-model="newCampaign.name" required />
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="">Description</label>
								<div class="input-group mb-3">
									<textarea class="form-control" placeholder="Campaign description" v-model="newCampaign.description" />
								</div>
							</div>
							<div class="form-group mb-2">
								<label for="">UTM Campaign</label>
								<div class="input-group mb-3">
									<utm-campaign-input v-model="newCampaign.utm_campaign" />
								</div>
							</div>
							<div class="form-group mb-2">
								<label>UTM Content</label>
								<utm-content-input v-model="newCampaign.utm_content" />
							</div>
							<div v-if="!loadingCampaignObjects">
								<span class="badge badge-primary bg-success w-100 py-3"
									><h4 class="m-0 p-0">{{ newCampaign.campaignObjects.length }} municipalities</h4></span
								>
							</div>
							<div v-else>
								<div class="d-flex justify-content-center">
									<div class="spinner-border" role="status">
										<span class="visually-hidden">Loading...</span>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
							<button type="submit" class="btn btn-primary">
								<font-awesome-icon :icon="['fas', loadingCampaingCreate ? 'spinner' : 'save']" :class="[loadingCampaingCreate ? 'fa-spin' : '']" /> Create
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PageHeader from '@/components/layout/PageHeader'
import UtmCampaignInput from '@/components/common/UtmCampaignInput'
import UtmContentInput from '@/components/common/UtmContentInput'
import { mapState } from 'vuex'
import { Modal } from 'bootstrap'
import { handleErrors } from '../../actions/helpers'
import restApi from '../../api/index.js'
import { gmapApi } from 'vue2-google-maps'
import MunicipalityAdvancedSearch from '@/components/municipality/MunicipalityAdvancedSearch'

export default {
	name: 'MunicipalityMap',
	components: {
		UtmCampaignInput, UtmContentInput,
		PageHeader,
		MunicipalityAdvancedSearch,
	},
	data() {
		return {
			loading: false,
			loadingInfo: false,
			showingResults: false,
			zoom: 4,
			center: { lat: 44.8228, lng: -87.366 },
			defaultCenter: { lat: 44.8228, lng: -87.366 },
			selectedMunicipality: null,
			municipalityCenter: { lat: 44.8228, lng: -87.366 },
			municipalityZoom: 7,
			radius: '', // In miles
			municipalities: [],
			markers: [],
			states: [],
			counties: [],
			municipalitiesList: [],
			sameState: false,
			sameCounty: false,
			twClient: false,
			hgClient: false,
			notTwClient: false,
			notHgClient: false,
			skipIfSentInLast4Weeks: false,
			$campaignModal: null,
			newCampaign: {
				name: '',
				description: '',
				utm_campaign: '',
				utm_content: '',
				filters: '',
				municipalities_count: '',
				clients: true,
				objects_type: 'municipality',
				campaignObjects: [],
			},
			loadingCampaignObjects: false,
			loadingCampaingCreate: false,
			showInfo: false,
			municipalityInfo: null,
			municipalityCenterZoom: 7,
			params: {},
			selectedPolygonIndex: null,
			polygonPaths: [
				{ lat: 44.815, lng: 20.46 },
				{ lat: 44.82, lng: 20.47 },
				{ lat: 44.81, lng: 20.475 },
			],
			polygons: [],
			polygonTwClient: false,
			polygonHgClient: false,
			polygonNotTwClient: false,
			polygonNotHgClient: false,
			polygonSkipIfSentInLast4Weeks: false,
		}
	},
	computed: {
		...mapState(['authUser', 'storageUrl']),
		google: gmapApi,
	},
	created() {},
	mounted() {
		this.$campaignModal = new Modal('#campaignModal')

		this.getAllPolygons()
	},
	methods: {
		getPrecisePolygonCenter(paths) {
			let area = 0
			let lat = 0
			let lng = 0
			const points = [...paths, paths[0]] // zatvori poligon

			for (let i = 0; i < points.length - 1; i++) {
				const xi = points[i].lng
				const yi = points[i].lat
				const xi1 = points[i + 1].lng
				const yi1 = points[i + 1].lat

				const a = xi * yi1 - xi1 * yi
				area += a
				lng += (xi + xi1) * a
				lat += (yi + yi1) * a
			}

			area *= 0.5
			const factor = 1 / (6 * area)
			return {
				lat: lat * factor,
				lng: lng * factor,
			}
		},

		onPolygonChange() {
			this.center = { lat: 44.8228, lng: -87.366 }

			this.municipalities = []
			this.municipalitiesList = []
			this.radius = ''
			if (this.selectedPolygonIndex == 'null') {
				this.polygonPaths = []
				return
			}
			this.polygonPaths = JSON.parse(this.polygons[this.selectedPolygonIndex].polygon)
			this.zoom = 6
			this.center = this.getPrecisePolygonCenter(this.polygonPaths)
		},

		getAllPolygons() {
			restApi
				.get('/map-polygons')
				.then(({ data }) => {
					this.polygons = data
					this.loading = false
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error fetching municipalities in radius data',
						timer: 6000,
					})
					this.loading = false
				})
		},

		getPolygonPath(polygonId) {
			restApi
				.get('/map-polygons/' + polygonId)
				.then(({ data }) => {
					this.polygonPaths = JSON.parse(data.polygon)
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error fetching polygon data',
						timer: 6000,
					})
				})
		},

		applyPolygonFilters() {
			if (!this.selectedPolygonIndex && this.selectedPolygonIndex !== 0) {
				alert('Please select a polygon')
				return
			}

			this.getMunicipalitiesInPolygon()
			this.showingResults = true
		},

		getMunicipalitiesInPolygon() {
			this.loading = true
			restApi
				.post('/municipalities/inPolygon', {
					type: 'polygon',
					polygon: this.polygonPaths,
					twClient: this.polygonTwClient,
					hgClient: this.polygonHgClient,
					notTwClient: this.polygonNotTwClient,
					notHgClient: this.polygonNotHgClient,
					skipIfSentInLast4Weeks: this.polygonSkipIfSentInLast4Weeks,
				})
				.then(({ data }) => {
					this.municipalities = data
					this.newCampaign.campaignObjects = data
					this.loading = false
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error fetching municipalities in radius data',
						timer: 6000,
					})
					this.loading = false
				})
		},

		// Export municipalities in polygon
		exportMunicipalitiesInPolygon() {
			this.loading = true

			restApi
				.post(
					'/municipalities/inPolygonExport',
					{
						type: 'polygon',
						polygon: this.polygonPaths,
						twClient: this.polygonTwClient,
						hgClient: this.polygonHgClient,
						notTwClient: this.polygonNotTwClient,
						notHgClient: this.polygonNotHgClient,
						skipIfSentInLast4Weeks: this.polygonSkipIfSentInLast4Weeks,
					},
					{
						responseType: 'blob',
					}
				)
				.then(response => {
					const blob = new Blob([response.data], { type: 'text/csv' })
					const url = window.URL.createObjectURL(blob)
					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'municipalities_export.csv')
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
					window.URL.revokeObjectURL(url)

					this.loading = false
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error exporting municipalities in polygon data',
						timer: 6000,
					})
					this.loading = false
				})
		},

		isMunicipalityWithinRadius(municipalityLat, municipalityLng, centerLat, centerLng, radiusMiles) {
			const earthRadiusMiles = 3959 // Radius of the Earth in kilometers
			const dLat = (municipalityLat - centerLat) * (Math.PI / 180)
			const dLng = (municipalityLng - centerLng) * (Math.PI / 180)
			const a =
				Math.sin(dLat / 2) * Math.sin(dLat / 2) +
				Math.cos(centerLat * (Math.PI / 180)) * Math.cos(municipalityLat * (Math.PI / 180)) * Math.sin(dLng / 2) * Math.sin(dLng / 2)
			const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
			const distanceKm = earthRadiusMiles * c

			return distanceKm <= radiusMiles
		},

		inputLocation(place) {
			console.log(place)
			console.log(place.geometry.location.lat())
			console.log(place.geometry.location.lng())
		},

		getMunicipality(id) {
			this.loadingInfo = true
			restApi
				.get('/municipalities/' + id)
				.then(({ data }) => {
					this.municipalityInfo = data
					this.loadingInfo = false
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error fetching municipalities in radius data',
						timer: 6000,
					})
					this.loadingInfo = false
				})
		},

		showMunicipalityInfo(m) {
			this.getMunicipality(m.id)
			this.showInfo = true
		},

		applyMunicipalityFilters() {
			this.center = this.municipalityCenter
			this.zoom = 7
			this.municipalities = []
			this.municipalities.push(this.selectedMunicipality)
			this.getMunicipalitiesInRadius()
			this.showingResults = true
		},

		choosenMunicipality(municipality) {
			this.selectedMunicipality = municipality
			this.municipalityCenter = { lat: parseFloat(municipality.lat), lng: parseFloat(municipality.lng) }
		},

		changeMunicipality() {
			this.selectedMunicipality = null
			this.showingResults = false
			this.municipalities = []
			this.center = this.defaultCenter
		},

		getMunicipalitiesInRadius() {
			this.loading = true
			restApi
				.post('/municipalities/inRadius', {
					type: 'radius',
					radius: this.radius,
					municipality: this.selectedMunicipality,
					twClient: this.twClient,
					hgClient: this.hgClient,
					notTwClient: this.notTwClient,
					notHgClient: this.notHgClient,
					skipIfSentInLast4Weeks: this.skipIfSentInLast4Weeks,
					sameState: this.sameState,
					sameCounty: this.sameCounty,
				})
				.then(({ data }) => {
					this.municipalities = data
					this.newCampaign.campaignObjects = data
					this.loading = false
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error fetching municipalities in radius data',
						timer: 6000,
					})
					this.loading = false
				})
		},

		// Export municipalities in radius
		exportMunicipalitiesInRadius() {
			this.loading = true

			restApi
				.post(
					'/municipalities/inRadiusExport',
					{
						type: 'radius',
						radius: this.radius,
						municipality: this.selectedMunicipality,
						twClient: this.twClient,
						hgClient: this.hgClient,
						notTwClient: this.notTwClient,
						notHgClient: this.notHgClient,
						skipIfSentInLast4Weeks: this.skipIfSentInLast4Weeks,
						sameState: this.sameState,
						sameCounty: this.sameCounty,
					},
					{
						responseType: 'blob',
					}
				)
				.then(response => {
					const blob = new Blob([response.data], { type: 'text/csv' })
					const url = window.URL.createObjectURL(blob)
					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', 'municipalities_export.csv')
					document.body.appendChild(link)
					link.click()
					document.body.removeChild(link)
					window.URL.revokeObjectURL(url)

					this.loading = false
				})
				.catch(error => {
					console.log(error)
					this.$swal.fire({
						icon: 'error',
						title: 'Error exporting municipalities in radius data',
						timer: 6000,
					})
					this.loading = false
				})
		},

		// Get all municipalities from map to delivery objects
		getCampaignMunicipalities() {
			this.newCampaign.campaignObjects = this.municipalities
		},

		// Create campaign
		createCampaign() {
			this.loadingCampaingCreate = true
			this.newCampaign.filters = ''
			this.newCampaign.municipalities_count = this.municipalities.length
			this.newCampaign.campaignObjects = this.prepareIds()
			// Store new campaign
			restApi
				.post(`/campaigns`, this.newCampaign)
				.then(({ data }) => {
					this.$campaignModal.hide()
					this.$router.push(`/campaigns/edit/${data.id}`)
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},

		prepareIds() {
			let ids = []
			this.municipalities.forEach(muny => {
				ids.push(muny.id)
			})
			return ids
		},
	},
	watch: {
		municipalities: function() {
			this.markers = []
			this.municipalities.forEach(municipality => {
				let marker = {
					position: { lat: parseFloat(municipality.lat), lng: parseFloat(municipality.lng) },
					title: municipality.full_name,
					population: municipality.population,
					id: municipality.id,
				}
				this.markers.push(marker)
			})
		},
	},
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.map-conteiner {
	position: relative;
	.vue-map {
		border-radius: 10px !important;
	}
}

.map-overlay-info {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	height: 100%;
	width: 100%;
	z-index: 999;
	background-color: rgba(0, 0, 0, 0.8);
}

.municipality-info {
	min-width: 500px;
}

.map-overlay-loading {
	display: flex;
	justify-content: center;
	align-items: center;
	position: absolute;
	height: 100%;
	width: 100%;
	z-index: 999;
	background-color: rgba(0, 0, 0, 0.5);
}

.multiselect__tag {
	padding: 5px 20px 5px 5px !important;
	margin-top: 0px !important;
	margin-bottom: 0px;
	max-height: 23px;
	min-height: 23px;
}

.multiselect__tags {
	display: block;
	width: 100%;
	padding: 0.375rem 0.75rem;
	font-size: 0.8rem;
	font-weight: 400;
	line-height: 1.6;
	color: #212529;
	background-color: #f8fafc;
	background-clip: padding-box;
	border: 1px solid #ced4da;
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	border-radius: 0.5rem;
	transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
	box-shadow: inset 0 -1px 0 #ddd;
	transition: box-shadow 0.2s;
	min-height: 23px;
}

.multiselect__placeholder {
	color: #adadad;
	display: inline-block;
	margin-bottom: 0px;
	padding-top: 2px;
}

.multiselect__tags-wrap {
	display: inline;
}
</style>
